import React from 'react'
import { Button, Row, Col } from 'react-bootstrap'
import { IoIosSearch as SearchIcon } from 'react-icons/io'
import { i18nTranslate } from 'src/utils'
import { CommonForm } from 'src/views/components/CommonForm'
import { renderFormInput } from './formInput'
import { Form } from 'react-bootstrap'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { teamContainer, userContainer } from 'src/models'
import './styles.scss'
//

@observer
class EditTeam extends React.Component {
  @observable
  currentlySelected = []
  @observable
  searchUserInput = ''
  @observable shouldShowRemoveConfirmation = false

  componentDidUpdate(prevProps) {
    if (!prevProps.isActive) {
      this.shouldShowRemoveConfirmation = false
    }
  }
  handleRemoveToggle = () => {
    this.shouldShowRemoveConfirmation = !this.shouldShowRemoveConfirmation
  }
  renderSubmitButtonGroup = propsFromForm => {
    const { onToggle } = this.props
    const teamid = this.props.team.id
    const { usersData } = this.props
    const isUserTeam = usersData.find(Userteam => {
      return teamid === Userteam.teamId
    })
    const isDisable = isUserTeam !== undefined ? true : false
    // const size = application.isMobile ? 'md' : 'lg'
    return (
      <Row
        noGutters
        className="edit-team-buttons-wrapper d-flex flex-row m-0 mt-3">
        <Col lg={3} md={4} className="px-2">
          <Button
            className="btn-primary team-save-button d-flex p-0 justify-content-center align-items-center py-2 my-2"
            // size={size}
            type="submit"
            data-testid="qa-team-save-changes">
            {i18nTranslate('team.saveChanges', 'Save Changes')}
          </Button>
        </Col>
        <Col lg={3} md={4} className="px-2">
          <Button
            variant="outline-primary"
            className="team-cancel-button d-flex p-0 justify-content-center align-items-center py-2 my-2"
            // size={size}
            onClick={event => {
              onToggle({ isOpen: false })
              propsFromForm.resetForm()
              event.preventDefault()
            }}
            data-testid="qa-cancel-team-management">
            {i18nTranslate('team.cancel', 'Cancel')}
          </Button>
        </Col>
        <Col
          lg={6}
          md={4}
          className="d-flex p-0 justify-content-center align-items-center py-2 my-2">
          <Button
            variant="link"
            onClick={this.handleRemoveToggle}
            disabled={isDisable}
            data-testid="qa-delete-team-management">
            {i18nTranslate('team.remove', 'Delete Team')}
          </Button>
        </Col>
      </Row>
    )
  }
  handleDeleteTeam = async event => {
    event.preventDefault()
    const teamId = this.editForm.id
    await teamContainer.deleteTeam(teamId)
    this.props.onToggle({ isOpen: false })
  }
  renderRemoveButtonGroup = () => {
    return (
      <Row
        noGutters
        className="edit-team-buttons-wrapper d-flex flex-row justify-content-end m-0 mt-3">
        <Col lg={6} md={6} className="px-2">
          <span className="text-danger" data-testid="qa-remove-team">
            {i18nTranslate(
              'team.confirmation',
              'Are you sure you want to remove this team'
            )}
            ?
          </span>
        </Col>
        <Col lg={3} md={3} className="px-2">
          <Button
            className="team-remove-button btn-primary d-flex p-0 justify-content-center align-items-center py-2 my-2"
            onClick={this.handleDeleteTeam}
            data-testid="qa-delete-team">
            {i18nTranslate('team.removeTeam', 'Delete')}
          </Button>
        </Col>
        <Col lg={3} md={3} className="px-2">
          <Button
            variant="outline-primary"
            className="team-cancel-button d-flex p-0 justify-content-center align-items-center py-2 my-2"
            onClick={this.handleRemoveToggle}
            data-testid="qa-cancel-team">
            {i18nTranslate('team.cancelChanges', 'Cancel')}
          </Button>
        </Col>
      </Row>
    )
  }

  handleSubmitButton = async data => {
    const teamId = this.editForm.id
    // const formElements = [...formFields.elements]
    // formElements.forEach(formField => {
    //   if (formField.checked) {
    //     const teamIdUserId = formField.id
    //     const userId = teamIdUserId.split('_')[1]
    //     teamBuyer.push({
    //       userId,
    //     })
    //   }
    // })

    const { description, teamName, costCenter, status } = data
    const teamData = {
      id: teamId,
      editedData: {
        name: teamName,
        description: description,
        status: status,
        costCentreId: parseInt(costCenter),
        teamBuyer: [],
      },
    }
    await teamContainer.updateTeam(teamData)
    this.props.onToggle({ isOpen: false })
  }
  handleSearchChange = event => {
    event.preventDefault()
    event.stopPropagation()
    this.searchUserInput = event.target.value
  }
  renderSearchUsersForm = () => {
    const placeHolderText = i18nTranslate(
      'userForTeamSearchPlaceholder',
      'Search users'
    )
    return (
      <>
        <div className="mb-2">{i18nTranslate('user.teamSize', 'Users')}</div>
        <Form className="user-search-bar position-relative">
          <Form.Control
            type="text"
            // value={this.searchUserInput}
            onChange={this.handleSearchChange}
            data-testid="qa-search-input"
            aria-label={i18nTranslate(
              'input.searchInput',
              'search input textbox',
              {
                nameSpace: 'ssr-resource',
              }
            )}
            placeholder={placeHolderText}
          />
          <SearchIcon
            className="search-icon"
            onClick={this.handleSearchChange}
            data-testid="qa-search-icon"
            aria-label={i18nTranslate('icons.searchicon', 'search icon', {
              nameSpace: 'ssr-resource',
            })}
          />
        </Form>
      </>
    )
  }
  renderUsersWithCheckbox = () => {
    return userContainer.userData.map((user, index) => {
      const isSelected =
        this.props.team.teamBuyer &&
        this.props.team.teamBuyer.findIndex(
          alreadySelectedUser => alreadySelectedUser.userId == user.id
        ) > -1
      const userEmail = user?.buyerInfo?.email || ''
      return (
        <div
          key={this.props.team.id + '_' + user.id}
          className={userEmail.includes(this.searchUserInput) ? '' : ' d-none'}>
          <Form.Check
            inline
            label={userEmail}
            key={user.id}
            type="checkbox"
            className="user-checkbox"
            defaultChecked={isSelected}
            id={this.props.team.id + '_' + user.id}
            // id has to be unique, so use teamid_userid
          />
        </div>
      )
    })
  }
  renderUsersForm = () => {
    return (
      <>
        <Form
          id={this.props.team.id}
          key={this.props.team.id}
          ref={el => (this.usersForm = el)}
          className="users-list-form">
          {this.renderUsersWithCheckbox()}
        </Form>
      </>
    )
  }
  renderUsers = () => {
    return (
      <>
        <Col className="user-search p-0">{this.renderSearchUsersForm()}</Col>
        <Col className="p-2 mt-2 border">{this.renderUsersForm()}</Col>
      </>
    )
  }

  render() {
    const userRenderProp = this.renderUsers()
    const formInput = renderFormInput(this.props, userRenderProp)
    const formRowStyles = {
      formRowClassName: 'mb-lg-3',
      formColumnClassName: '',
    }
    // this.allUsers.map((user, index) => {
    // const isSelected = this.props.team.selectedUsers.includes(user)
    // if (isSelected) {
    //   this.currentlySelected.push(index)
    // }
    // })

    //redundant
    // this.currentlySelected = [...this.props.team.selectedUsers]
    return (
      <Row
        noGutters
        className="pt-1"
        id={this.props.team.name}
        key={this.props.team.name}>
        {/*this.currentlySelected.map(team => (
          <div>{team}</div>
        ))*/}
        <Col className="p-0">
          <div
            id={this.props.team.id}
            key={this.props.team.id}
            ref={el => (this.editForm = el)}>
            <CommonForm
              formTypeJson={formInput}
              classNameValue={formRowStyles}
              SubmitButtonProps={
                this.shouldShowRemoveConfirmation
                  ? this.renderRemoveButtonGroup
                  : this.renderSubmitButtonGroup
              }
              hasInlineSubmitButton={false}
              onSubmit={this.handleSubmitButton}
            />
          </div>
        </Col>
      </Row>
    )
  }
}

export default EditTeam
export { EditTeam }
